import React, { useState, useEffect } from 'react';
import SettingIcon from 'assets/icon/SettingIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import HalfStarIcon from 'assets/icon/HalfStarIcon';
import PackageIcon from 'assets/icon/PackageIcon';
import TransferIcon from 'assets/icon/TransferIcon';
import UserIcon from 'assets/icon/UserIcon';
import CategoryIcon from 'assets/icon/CategoryIcon';
import MenuIcon from 'assets/icon/MenuIcon';
import ExitIcon from 'assets/icon/ExitIcon';

export default function Sidebar({ isOpen, toggleSidebar, onSidebarClick, menuAccess }) {
	const [isSidebarHome, setIsSidebarHome] = useState(true)
	const [isAdmin, setIsAdmin] = useState("0")
	// const [isOpen, setIsOpen] = useState(localStorage.getItem("SidebarState") === "open" ? true : false);
	
	let pathArray = window.location.pathname.split("/")
	
	const logoutBtnClick = () => {
		localStorage.removeItem("Token")
		localStorage.removeItem("Username")
		localStorage.removeItem("FirstName")
		localStorage.removeItem("LastName")
		localStorage.removeItem("Email")

		window.location.href = "/login"
	}
	// const toggleSidebar = () => {
	// 	setIsOpen(prev => {
	// 		const next = !prev;
	// 		localStorage.setItem("SidebarState", next ? "open" : "close");
	// 		return next;
	// 	});
	// };

	useEffect(() => {
		setIsAdmin(localStorage.getItem("IsAdmin"))
		// setIsAdmin("1")
	}, [])
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20 
			${ isOpen ? 'w-64' : 'hidden md:block sm:w-20' } `}
		>
			<div className={`h-screen flex flex-col gap-2 lg:text-base py-4 w-full`}>
				<div className={`hidden sm:flex gap-3 ${ isOpen ? 'justify-start' : 'justify-center' } px-4`}>
					<button className='block' onClick={toggleSidebar}>
						<MenuIcon className='fill-black w-5' />
					</button>
					{ isOpen && (<span className={`font-semibold italic`}>Padel Port</span>)}
				</div>

				<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto pt-5">
					
					<a className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/' ? 'bg-black text-white fill-white' : '' } 
							${ isOpen ? 'px-4' : 'justify-center px-2' } 
						`}
						onClick={onSidebarClick}
						href="/"
					>
						<DashboardIcon className='w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Dashboard</p>
					</a>

					<div className={`
							${ isOpen ? 'block' : 'hidden' }
						`}>
						<span className='text-gray-400'>Transaction</span>
					</div>
					
					<SidebarCard
						title='Transaction'
						path='/transaction'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Sales Order'
						path='/sales-order'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Rental Order'
						path='/rental-order'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<TransferIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Customer'
						path='/customer'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<UserIcon className='w-6' />
					</SidebarCard>

					<div className={`
							${ isOpen ? 'block' : 'hidden' }
						`}>
						<span className='text-gray-400'>Master Data</span>
					</div>

					<SidebarCard
						title='Sales Stock'
						path='/sales-stock'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Rental Stock'
						path='/rental-stock'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Product'
						path='/product'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<PackageIcon className='w-6' />
					</SidebarCard>
					
					<SidebarCard
						title='Brand'
						path='/brand'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<HalfStarIcon className='w-6' />
					</SidebarCard>

					<SidebarCard
						title='Category'
						path='/category'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<CategoryIcon className='w-6 h-6' />
					</SidebarCard>
					
					<SidebarCard
						title='Setting'
						path='/setting'
						isOpen={isOpen}
						onClick={onSidebarClick}
					>
						<SettingIcon className='w-6' />
					</SidebarCard>

					<button className='button flex justify-center mt-5 mb-5 w-full' onClick={logoutBtnClick}>
						{isOpen ? 
							<span className=''>Log Out</span> :
							<ExitIcon className='fill-white w-6 h-6' />
						}
					</button>
				</div>
			</div>	
		</div>
  	)
}

const SidebarCard = ({ title, path, isOpen, onClick, children }) => {
	return(
		<a
			className={`w-full py-3 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				${ window.location.pathname.includes(path) ? 'bg-black text-white fill-white' : '' } 
				${ isOpen ? 'px-4' : 'justify-center px-2' }
			`}
			onClick={onClick}
			href={ path }
		>
			{ children }
			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>{ title }</p>
		</a>
	)
}
